import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

export const SearchForm = ({
                               location: locationDefault  = '',
                               term: termDefault = '',
                               radius: radiusDefault = 15,
                               onSubmit,
                               products = [],
                               product: productDefault = null,
                           }) => {
    const [location, setLocation] = useState(locationDefault)
    const [term, setTerm] = useState(termDefault)
    const [radius, setRadius] = useState(radiusDefault)
    const [product, setProduct] = useState(productDefault)

    useEffect(() => {
        setLocation(locationDefault)
        setTerm(termDefault)
        setRadius(radiusDefault)
        setProduct(productDefault)
    }, [locationDefault, termDefault, radiusDefault, productDefault])

    const [error, setError] = useState()
    const [searching, setSearching] = useState(false)
    const radiusChoices = [15, 20, 35]

    const handleSubmit = (e) => {
        e.preventDefault()

        const search = {
            location,
            term,
            radius,
            product,
        }

        // remove empty elements
        const cleanSearch = Object.fromEntries(Object.entries(search).filter(([_, v]) => v != null))

        setSearching(true)
        setError(null)
        onSubmit(cleanSearch)
            .catch(e => {
                console.log(e)
                setError(e) // todo convert to string
            }).finally(() => {
                setSearching(false)
            })
    }

    return <div className="ds-search-container">
        <form onSubmit={handleSubmit}>
        {error && <div>Error</div>}
            <div className="ds-flex-box">
                <div className="ds-search-location">
                    <input type="text" value={location} placeholder="Enter City, Zip Code, or Address" className="ds-form-input" onChange={e => setLocation(e.target.value)} />
                </div>
                <div className="ds-search-name">
                    <input type="text" value={term} placeholder="Doctor or Practice Name" className="ds-form-input" onChange={e => setTerm(e.target.value)} />
                </div>
                {products.length > 0 &&
                    <div className="ds-search-products">
                        <select defaultValue={product} className="ds-form-select" onChange={e => setProduct(e.target.value)}>
                            <option
                                value=""
                                key="_blank_"
                            >-- With Product --
                            </option>
                            {products.map(product => (
                                <option
                                    value={product.id}
                                    key={product.id}
                                >{product.title}</option>
                            ))}
                        </select>
                    </div>
                }
                <div className="ds-search-actions">
                    <button type="submit" disabled={(location.length + term.length === 0) || searching} className="ds-button"><i className="fa fa-search" /> Search</button>
                </div>
            </div>
        </form>
    </div>
}

SearchForm.propTypes = {
    onSubmit: PropTypes.func,
    location: PropTypes.string,
    term: PropTypes.string,
    radius: PropTypes.number,
    products: PropTypes.array,
}
